export default [
  {
    book_id: 'twf-008',
    id: 1,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:35.000Z',
  },
  {
    book_id: 'twf-009',
    id: 9,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:36.000Z',
  },
  {
    book_id: 'twf-002',
    id: 10,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:30.000Z',
  },
  {
    book_id: 'twf-001',
    id: 11,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:29.000Z',
  },
  {
    book_id: 'twf-003',
    id: 12,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:31.000Z',
  },
  {
    book_id: 'twf-004',
    id: 13,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:31.000Z',
  },
  {
    book_id: 'twf-005',
    id: 14,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:32.000Z',
  },
  {
    book_id: 'twf-006',
    id: 15,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:33.000Z',
  },
  {
    book_id: 'twf-007',
    id: 16,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:34.000Z',
  },
  {
    book_id: 'twf-010',
    id: 17,
    lat: '41.852',
    lng: '-87.681',
    time: '2012-11-05T07:34:37.000Z',
  },
  { book_id: 'twf-009', id: 18, lat: '41.896', lng: '-87.672' },
  { book_id: 'twf-002', id: 19, lat: '42.005', lng: '-87.663' },
  { book_id: 'twf-001', id: 20, lat: '41.963', lng: '-87.712' },
  { book_id: 'twf-006', id: 23, lat: '30.276', lng: '-97.730' },
  { book_id: 'twf-007', id: 24, lat: '41.853', lng: '-87.669' },
  { book_id: 'twf-007', id: 25, lat: '42.025', lng: '-87.944' },
  { book_id: 'twf-003', id: 26, lat: '41.496', lng: '-90.553' },
  { book_id: 'twf-007', id: 27, lat: '41.725', lng: '-88.267' },
  { book_id: 'twf-007', id: 29, lat: '33.975', lng: '-118.356' },
  {
    book_id: 'twf-006',
    id: 30,
    lat: '30.263',
    lng: '-97.719',
    time: '2013-03-04T03:01:13.000Z',
  },
  {
    book_id: 'twf-009',
    id: 33,
    lat: '39.930',
    lng: '-75.162',
    time: '2013-05-14T20:32:11.000Z',
  },
  {
    book_id: 'twf-003',
    id: 35,
    lat: '44.961',
    lng: '-93.209',
    time: '2013-05-29T17:30:40.000Z',
  },
  {
    book_id: 'twf-005',
    id: 36,
    lat: '41.916',
    lng: '-87.711',
    time: '2013-06-22T19:30:27.000Z',
  },
  { book_id: 'twf-010', id: 48, lat: '41.985', lng: '-87.694' },
  { book_id: 'twf-005', id: 49, lat: '41.921', lng: '-87.695' },
  { book_id: 'twf-005', id: 50, lat: '41.597', lng: '-87.808' },
  { book_id: 'twf-006', id: 51, lat: '45.566', lng: '-122.670' },
  { book_id: 'twf-005', id: 52, lat: '41.466', lng: '-81.694' },
  { book_id: 'twf-003', id: 53, lat: '41.540', lng: '-90.580' },
  { book_id: 'twf-003', id: 54, lat: '53.800', lng: '-1.549' },
  { book_id: 'twf-003', id: 55, lat: '41.663', lng: '-91.555' },
  { book_id: 'twf-003', id: 56, lat: '41.659', lng: '-91.538' },
  { book_id: 'twf-004', id: 57, lat: '41.896', lng: '-87.677' },
  { book_id: 'twf-004', id: 58, lat: '37.754', lng: '-122.431' },
  { book_id: 'twf-004', id: 59, lat: '37.765', lng: '-122.396' },
]



// WEBPACK FOOTER //
// ./src/data/books/index.js